import KeenSlider from 'keen-slider';

function navigation(slider) {
    let wrapper, arrowLeft, arrowRight;

    function markup(remove) {
        wrapperMarkup(remove);
        arrowMarkup(remove);
    }

    function removeElement(element) {
        element.parentNode.removeChild(element);
    }
    function createDiv(className) {
        var div = document.createElement('div');
        var classNames = className.split(' ');
        classNames.forEach((name) => div.classList.add(name));
        return div;
    }

    function arrowMarkup(remove) {
        if (remove) {
            removeElement(arrowLeft);
            removeElement(arrowRight);
            return;
        }
        arrowLeft = createDiv('arrow arrow--left');
        arrowLeft.addEventListener('click', () => slider.prev());
        arrowRight = createDiv('arrow arrow--right');
        arrowRight.addEventListener('click', () => slider.next());

        wrapper.appendChild(arrowLeft);
        wrapper.appendChild(arrowRight);
    }

    function wrapperMarkup(remove) {
        if (remove) {
            var parent = wrapper.parentNode;
            while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper);
            removeElement(wrapper);
            return;
        }
        wrapper = createDiv('navigation-wrapper');
        slider.container.parentNode.appendChild(wrapper);
        wrapper.appendChild(slider.container);
    }

    function updateClasses() {
        var slide = slider.track.details.rel;
        slide === 0 ? arrowLeft.classList.add('arrow--disabled') : arrowLeft.classList.remove('arrow--disabled');
        (slide === slider.track.details.maxIdx) ? arrowRight.classList.add('arrow--disabled') : arrowRight.classList.remove('arrow--disabled');
    }

    slider.on('created', () => {
        markup();
        updateClasses();
    });
    slider.on('optionsChanged', () => {
        markup(true);
        markup();
        updateClasses();
    });
    slider.on('slideChanged', () => {
        updateClasses();
    });
    slider.on('destroyed', () => {
        markup(true);
    });
}

let slider;
let cards;

changeCards();
window.addEventListener('resize', changeCards);

function changeCards() {
    if (window.innerWidth > 991) {
        cards = 4;
    } else if (window.innerWidth < 992 && window.innerWidth > 575) {
        cards = 3;
    } else if (window.innerWidth < 576 && window.innerWidth > 449) {
        cards = 2;
    } else {
        cards = 1;
    }

    if (slider) {
        slider.update({
            loop: false,
            slides: {
                perView: cards,
                spacing: 21,
            },
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    slider = new KeenSlider(
        '.slider-wrapper',
        {
            loop: false,
            slides: {
                perView: cards,
                spacing: 21,
            },
        },
        [navigation]
    );
});
